import { ENV } from '@/enum/global';

const state = () => ({
    env: '', //server環境
    envData:{},
    logoutLink: '',
    nextLink: '',
    envBaseLink: '',
    backendLink: '',
    paUserCenterLink: '',
    wsLink: '',
    maintenance: false,
    maintenanceTime:{
        start: '',
        end: '',
    },
});

// getters
const getters = {
    getNextLink: function (state) {
        return state.nextLink
    },
    getLogoutLink: function (state) {
        return state.logoutLink
    },
    getBaseLink: function (state) {
        return state.envBaseLink
    },
    getPAUserCenterLink: function (state) {
        return state.paUserCenterLink
    },
    getWSLink: function(state){
        return state.wsLink;
    },
};

// actions
const actions = {


};

// mutations
const mutations = {
    setEnv(state, data) {
        state.env = data;
    },
    setEnvInfo(state, data) {
        state.envData = data;
    },
    setNextLink(state, param) {
        state.nextLink = param;
    },
    setLogoutLink(state, param) {
        state.logoutLink = param;
        // console.log('state',state.logoutLink)
    },
    setBaseLink(state, param) {
        // console.log('param',param)
        state.envBaseLink = param;
    },
    setPAUserCenterLink(state, param) {
        state.paUserCenterLink = param;
    },
    setENVLink(state, param){
        state[param.name] = param.val;
        let {name, val} = param
    },
    setMaintenance(state, param){
        state.maintenance = param;
    },
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};